import { sizeMap, SizeEnum, type SizeType } from '../_size';

/**
 * Icon Variant Classes
 */

const iconContainerBgClasses = 'bg-transparent block';
const iconContainerBgSizeClasses = 'p-0';

/**
 * Icon Blog Theme
 */

const iconBlogTheme = (size: SizeType) => ({
  iconContainerBgClasses,
  iconContainerBgSizeClasses,
  iconSizeClasses: sizeMap.get(SizeEnum[size]),
});

export default iconBlogTheme;
